/** Referrer hosts (and utm_source values) that mean "came from an AI assistant". */
const AI_REFERRER_SOURCES: readonly Readonly<{ source: string; hosts: readonly string[] }>[] = [
  { source: "chatgpt.com", hosts: ["chatgpt.com", "chat.openai.com"] },
  { source: "perplexity.ai", hosts: ["perplexity.ai"] },
  { source: "claude.ai", hosts: ["claude.ai"] },
  { source: "copilot.microsoft.com", hosts: ["copilot.microsoft.com"] },
  { source: "gemini.google.com", hosts: ["gemini.google.com"] },
];

function hostMatches(host: string, candidate: string): boolean {
  return host === candidate || host.endsWith(`.${candidate}`);
}

export function aiReferralSource(
  referer: string | null,
  utmSource: string | null,
): string | null {
  const utm = utmSource?.trim().toLowerCase();
  if (utm) {
    for (const { source, hosts } of AI_REFERRER_SOURCES) {
      if (hosts.some((host) => utm === host || hostMatches(utm, host))) return source;
    }
  }
  if (!referer) return null;
  let host: string;
  try {
    host = new URL(referer).hostname.toLowerCase();
  } catch {
    return null;
  }
  for (const { source, hosts } of AI_REFERRER_SOURCES) {
    if (hosts.some((candidate) => hostMatches(host, candidate))) return source;
  }
  return null;
}
